import { HopperAssets } from "@hopper-assets";
import { isHopperAppWebView } from "@hopper-b2b/utilities";
import { Box, Button, Grid, Link, Stack, Typography } from "@mui/material";
import { HopperLogoPrimary } from "../../assets";
import {
  FOOTER_DATA_EN,
  FOOTER_DATA_ES,
  FOOTER_DATA_FR,
  socials,
} from "./links";
export interface FooterProps {
  language: string;
}

export const Footer = ({ language }: FooterProps) => {
  const { columns } = getFooterDataByLocale(language);
  // Do not display any footers for the Hopper App WebView
  return isHopperAppWebView() ? null : (
    <Box
      component="footer"
      paddingTop={{
        mobile: 300,
        tablet: 600,
      }}
      paddingBottom={{
        mobile: 300,
        tablet: 850,
      }}
      paddingX={({ tokens }) => tokens.container.padding}
      width="100%"
    >
      <Stack
        maxWidth={({ tokens }) => tokens.container.maxWidth}
        gap={600}
        margin="auto"
      >
        <Stack
          direction={{
            tablet: "row",
          }}
          gap={300}
          justifyContent="space-between"
        >
          <Stack direction="row" gap={500}>
            <Box
              component={HopperLogoPrimary}
              width="120px"
              height="32px"
              color={({ tokens }) => tokens.brand.main}
            />
            <img
              src={HopperAssets.Ds["Logo-HTS_3x"]}
              width="88px"
              height="32px"
              alt="HTS"
            />
          </Stack>
          <Stack direction="row" gap={350} alignItems="center">
            {socials.map((social) => (
              <Button
                size="link"
                variant="ghost"
                key={social.platform}
                href={social.url}
                sx={{
                  minWidth: 0,
                }}
              >
                <Box
                  component={social.icon}
                  width="20px"
                  height="20px"
                  color={({ tokens }) => tokens.text.secondary}
                />
              </Button>
            ))}
          </Stack>
        </Stack>
        <Grid
          container
          columns={{
            mobile: 1,
            tablet: 3,
            desktop: 5,
          }}
          rowSpacing={600}
          columnSpacing={400}
          justifyContent="space-between"
          width="100%"
        >
          {columns.map((column) => (
            <Grid item key={column.header}>
              <Stack gap={150}>
                <Typography variant="titleSmall">{column.header}</Typography>
                <Stack gap={100} alignItems="flex-start">
                  {column.links.map((link) => (
                    <Link
                      key={link.title}
                      href={link.url}
                      variant="bodyMedium"
                      color={({ tokens }) => tokens.text.secondary}
                    >
                      {link.title}
                    </Link>
                  ))}
                </Stack>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Box>
  );
};

const getFooterDataByLocale = (locale: string) => {
  switch (locale) {
    case "en":
      return FOOTER_DATA_EN;
    case "fr":
      return FOOTER_DATA_FR;
    case "es":
      return FOOTER_DATA_ES;
    default:
      return FOOTER_DATA_EN;
  }
};
